import { root } from './root';
import { MapPolyfill } from './MapPolyfill';
export const Map = root.Map || (() => MapPolyfill)();
//# sourceMappingURL=Map.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/util/Map.js
// module id = 211
// module chunks = 4